import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useParams } from "react-router-dom";

export default function ActivityFormPage() {
    const { id } = useParams();
    const isEditMode = !!id; // تحديد ما إذا كنا في وضع التعديل أم الإضافة
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [activityType, setActivityType] = useState("");
    const [activitySpecialty, setActivitySpecialty] = useState("");
    const [description, setDescription] = useState("");
    const [isActive, setIsActive] = useState(true);

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (!isEditMode) return;
        const fetchActivity = async () => {
            try {
                const res = await backEnd_request.get(`/Activities/${id}`);
                const act = res.data;
                setActivityType(act.activityType ?? "");
                setActivitySpecialty(act.activitySpecialty ?? "");
                setDescription(act.description ?? "");
                setIsActive(act.isActive ?? true);
            } catch (err) {
                setErrorMessage("فشل جلب بيانات النشاط");
            }
        };
        fetchActivity();
    }, [id, isEditMode]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        // تجهيز البيانات: في حالة الإضافة نرسل فقط النوع، وفي التعديل نرسل الكل
        const payload = isEditMode
            ? { activityType, activitySpecialty, description, isActive }
            : { activityType, activitySpecialty: "", description: "", isActive: true };

        try {
            if (isEditMode) {
                await backEnd_request.post(`/Activities/${id}`, payload);
                navigate("/admin/activities-management", { state: { successMessage: "تم تحديث النشاط بنجاح ✅" } });
            } else {
                await backEnd_request.post("/Activities", payload);
                navigate("/admin/activities-management", { state: { successMessage: "تم إضافة النشاط بنجاح ✅" } });
            }
        } catch (err) {
            setErrorMessage(err.response?.data?.message || "حدث خطأ أثناء المعالجة");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                    {/* بطاقة الواجهة المحسنة */}
                    <div className="card shadow-sm border-0 rounded-3">
                        <div className="card-header bg-white py-3 border-bottom-0">
                            <h4 className="fw-bold text-primary mb-0">
                                {isEditMode ? "تعديل بيانات النشاط" : "إضافة نشاط جديد"}
                            </h4>
                            <p className="text-muted small">يرجى ملء البيانات التالية بدقة</p>
                        </div>

                        <div className="card-body p-4">
                            {errorMessage && (
                                <div className="alert alert-danger d-flex align-items-center" role="alert">
                                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                    {errorMessage}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                {/* هذا الحقل يظهر دائماً */}
                                <div className="mb-4">
                                    <label className="form-label fw-semibold">نوع النشاط</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-lg bg-light border-0"
                                        placeholder="ادخل اسم النشاط..."
                                        value={activityType}
                                        onChange={(e) => setActivityType(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* الحقول الإضافية تظهر فقط في وضع التعديل */}
                                {isEditMode && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">تخصص النشاط</label>
                                            <input
                                                type="text"
                                                className="form-control bg-light border-0"
                                                value={activitySpecialty}
                                                onChange={(e) => setActivitySpecialty(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">الوصف التفصيلي</label>
                                            <textarea
                                                className="form-control bg-light border-0"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                rows={4}
                                                required
                                            />
                                        </div>

                                        <div className="form-check form-switch mb-4">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                checked={isActive}
                                                onChange={(e) => setIsActive(e.target.checked)}
                                                id="isActiveSwitch"
                                            />
                                            <label className="form-check-label" htmlFor="isActiveSwitch">
                                                حالة النشاط (نشط / غير نشط)
                                            </label>
                                        </div>
                                    </>
                                )}

                                <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-light px-4"
                                        onClick={() => navigate("/admin/activities-management")}
                                    >
                                        إلغاء
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary px-5 shadow-sm"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                        ) : isEditMode ? "حفظ التغييرات" : "إضافة الآن"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}